import React from 'react';
import {useDispatch} from "react-redux";
import {showSearchBoxHandler} from "../../store/TableRedux/TableRedux";
import IconBtn from "../elements/IconBtn";
import {IoMdSearch} from "react-icons/io";

const ShowSearchBtn = () => {
    const dispatch = useDispatch();

    return (
        <div className=''>
            <IconBtn color='blueIconBtn '
                     onClick={() => dispatch(showSearchBoxHandler())}><IoMdSearch size={21}/></IconBtn>
        </div>
    );
};

export default ShowSearchBtn;